module.exports = __webpack_public_path__ + "static/media/chick.494f5398.gif";